import { useNavigate } from 'react-router-dom';
import { APP_ROUTES, OrgType } from '@/config/constants';
import { BodyMediumMidEmphasis, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import styles from './SubscriptionsBanner.styles';
import { AccessibleDivButton } from '@/components';

type Props = {
  type: string;
  institutionName?: string;
  schools: string[];
};

const MAX_NUMBER_SCHOOLS = 5;

const SubscriptionsBanner: React.FC<Props> = ({ type, institutionName, schools }) => {
  const navigate = useNavigate();
  const slidedSchools = schools.slice(0, MAX_NUMBER_SCHOOLS);
  const hasMoreSchools = schools.length > MAX_NUMBER_SCHOOLS;
  const amountExtraSchools = schools.length - MAX_NUMBER_SCHOOLS;
  const adjustCommunityArea = () => {
    navigate(APP_ROUTES.community);
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <TitleSmallEmphasized nonTranslate as="h1">
          {institutionName}
        </TitleSmallEmphasized>
      </div>
      <div className={styles.schoolsContainer}>
        {type === OrgType.school ? (
          <p>
            {slidedSchools.length > 1 &&
              slidedSchools.map((schoolName, schoolIndex) => (
                <span key={schoolName}>
                  <BodyMediumMidEmphasis
                    data-testid="school"
                    nonTranslate
                    color={colors.charcoal}
                    as="span"
                  >
                    {schoolName}
                  </BodyMediumMidEmphasis>
                  {schoolIndex < slidedSchools.length - 1 && (
                    <span className={styles.separator} aria-hidden="true">
                      {' • '}
                    </span>
                  )}
                </span>
              ))}
            {hasMoreSchools && (
              <BodyMediumMidEmphasis as="span" color={colors.charcoal}>
                {` and ${amountExtraSchools}+`}
              </BodyMediumMidEmphasis>
            )}
          </p>
        ) : (
          <AccessibleDivButton onClick={adjustCommunityArea}>
            <BodyMediumMidEmphasis as="span" className={styles.adjustArea} color={colors.shadesJungle800}>
              Adjust my community area
            </BodyMediumMidEmphasis>
          </AccessibleDivButton>
        )}
      </div>
    </div>
  );
};

export default SubscriptionsBanner;
